import { render } from "./edit.vue?vue&type=template&id=3bfbe46a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=3bfbe46a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3bfbe46a"

export default script